import PrimaryButton from "../../CommonButtons/PrimaryButton";
import SVGComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {boolean} props.activeStep - Active step state eg:- 0 or 1 or 2
 * @param {OnClickEventHandler} props.handleForwardAction - Handle funtion on pressing Next
 * @param {OnClickEventHandler} props.handleBackwardAction - Handle funtion on pressing Previous
 * @param {Array} props.dataArray - Array of objects that contains the data regarding the steps
 * @param {boolean} props.showExtraInfo - Controls animated visibility of extra info
 * @returns {JSX.Element}
 */
const PrimaryStepper = ({
  activeStep,
  handleForwardAction,
  handleBackwardAction,
  dataArray,
  showExtraInfo,
}) => {
  const currentStep = dataArray[activeStep];

  // helper to prepare button props
  const getButtonProps = (type) => {
    const isPrev = type === "previous";
    const isLoading = currentStep?.[`${type}IsLoading`];
    const anyLoaderActive = currentStep?.nextIsLoading;

    return {
      btnText: currentStep?.[`${type}Text`],
      handleFunction: () => {
        if (
          (!isLoading && currentStep?.[`nextIsEnabled`] && !isPrev) ||
          (isPrev && !anyLoaderActive)
        ) {
          isPrev ? handleBackwardAction() : handleForwardAction();
        }
      },
      enabledBgColor:
        currentStep?.[`nextIsEnabled`] && !isPrev
          ? currentStep?.[`${type}EnableBgColor`]
          : !currentStep?.[`nextIsEnabled`] && !isPrev
            ? currentStep?.[`${type}DisableBgColor`]
            : currentStep?.[`${type}EnableBgColor`],
      disabledBgColor: isPrev
        ? currentStep?.[`${type}EnableBgColor`]
        : currentStep?.[`${type}DisableBgColor`],
      enabledTextColor:
        (currentStep?.[`nextIsEnabled`] && !isPrev
          ? currentStep?.[`${type}EnableTextColor`]
          : !currentStep?.[`nextIsEnabled`] && !isPrev
            ? currentStep?.[`${type}DisableTextColor`]
            : currentStep?.[`${type}EnableTextColor`]) || "var(--text-primary)",
      hoverOption: currentStep?.[`${type}HoverOption`] || "white",
      isDisabled: isPrev
        ? anyLoaderActive
        : !currentStep?.[`nextIsEnabled`] || isLoading,
      isLoaderNeeded: (!isPrev && currentStep?.[`nextLoaderNeeded`]) || false,
      isLoading:
        (!isPrev && currentStep?.[`nextLoaderNeeded`] && isLoading) || false,
      inActiveVariantNeeded: true,
    };
  };
  const shouldShowExtraInfo =
    currentStep?.extraInfoShow &&
    (showExtraInfo === undefined || showExtraInfo === true);
  return (
    <div className="max-w-tab-width-normal w-width-full bg-primary-nav Qsmd:rounded-b-border-radius-md Qsmd:rounded-t-none rounded-t-border-radius-md Qsmd:shadow-box-shadow-bottom shadow-box-shadow-top absolute Qmd:top-top-base">
      <div className="max-w-tab-width-normal w-width-full h-auto flex justify-between items-center Qlg:gap-right-base gap-gap-md p-padding-md  relative">
        <div
          className={
            getButtonProps("previous").isDisabled
              ? "opacity-light-opacity pointer-events-none"
              : ""
          }
        >
          <PrimaryButton {...getButtonProps("previous")} />
        </div>
        <div className="flex justify-between items-end Qsmd:gap-gap-xl gap-gap-md w-[inherit] max-w-stepper-middle-bar-width">
          {dataArray?.map((val, index) => {
            const isActive = activeStep === index;
            return (
              <div
                className={`flex flex-col ${isActive ? "flex-1" : "flex-[0.5]"}`}
              >
                <div
                  className={`flex flex-col gap-gap-xs ${isActive ? "flex-[2] min-w-min-width-base transition-[flex-grow] duration-[var(--animation-slow)] ease-in-out origin-left" : "flex-[1]"} `}
                >
                  {isActive ? (
                    <div className="hidden Qsmd:flex text-text-primary text-font-xs truncate">
                      {val?.stepperText}
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div
                    className={`h-stepper-line-height bg-text-primary rounded-border-radius-md ${isActive ? "" : "opacity-light-opacity"}`}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>

        <div>
          <PrimaryButton {...getButtonProps("next")} />
        </div>
      </div>
      <div
        className={`flex-1 Qsmd:flex hidden overflow-hidden transition-all duration-animation-fast-s ease-in-out border-t-border border-t-primary-bg mx-margin-md
    ${
      shouldShowExtraInfo
        ? "max-h-[var(--stepper-header)] opacity-base-opacity pt-padding-sm pb-padding-md"
        : "max-h-[var(--height-base)] opacity-opacity-none pt-padding-base pb-padding-base"
    }
  `}
      >
        <div className="flex gap-gap-sm items-center">
          {currentStep?.extraInfoIconUrl ? (
            <SVGComponent
              url={currentStep.extraInfoIconUrl}
              height="var(--icon-md)"
              width="var(--icon-md)"
              color={currentStep.extraInfoIconColor || ""}
            />
          ) : null}

          <div className="flex flex-col gap-gap-xs">
            {currentStep?.extraInfoHeaderText ? (
              <div className="text-text-primary text-font-xs break-words">
                {currentStep.extraInfoHeaderText}
              </div>
            ) : null}

            {currentStep?.extraInfoSubText ? (
              <div className="text-text-secondary text-font-xs break-words">
                {currentStep.extraInfoSubText}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimaryStepper;
